import React from 'react';
import PropTypes from 'prop-types';
const BreadcrumbsBackLink = props => {
  const onClick = props.onClick,
    tier = props.tier,
    name = props.tier.name;
  const handleClick = e => {
    onClick(tier, e);
  };
  return /*#__PURE__*/React.createElement("button", {
    className: "sortButton btn-link",
    onClick: handleClick,
    role: "link",
    type: "button"
  }, name);
};
BreadcrumbsBackLink.propTypes = {
  tier: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
};
export default BreadcrumbsBackLink;